/**
 * Builds a translucent variant of a tone value.
 *
 * Appending a hex alpha suffix (`${tone}55`) breaks as soon as the tone is a
 * CSS variable or a named color, so use color-mix for every branch.
 */
export function toneAlpha(tone: string, percent: number): string {
  const pct = Math.max(0, Math.min(100, Math.round(percent)));
  return `color-mix(in srgb, ${tone} ${pct}%, transparent)`;
}
